"use strict";

define('components/filter_bar/table/bulk_email',['components/ajax'], function(ajax) {
    var bulkEmailComponent = {
        initWithContext: function(context) {
            var emailButton = context.buttonbarNode.find('.selection-email button');
            emailButton.click(function() {
                var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();
                var tableObjectType = context.tableFilterBarData.tableObjectType;

                if (tableObjectType == 3 || tableObjectType == 5 || tableObjectType == 6 || tableObjectType == 9) {

                    // The csrf_token will be added in the ajax call below.
                    var content = new FormData();
                    content.append("object_ids", JSON.stringify(objectIds));
                    if (window.location.pathname.startsWith("/account")) {
                        const objectIdFromUrl = Number(window.location.pathname.split('/')[2]);
                        if (objectIdFromUrl) {
                            content.append("email_batch_object_id", JSON.stringify(objectIdFromUrl));
                        }
                    }

                    ajax(emailButton.data('url'), {
                        formData: content
                    });
                }
            });
        }
    };

    return bulkEmailComponent;
});
